<template>
    <BreadCrumb PageTitle="Liste des questions" />
    <ListeQuestion />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeQuestion from "@/components/Question/ListeQuestion.vue";

  
  
  export default defineComponent({
    name: "ListeQuestionPage",
    components: {
      BreadCrumb,
      ListeQuestion,
    },
  });
  </script>